import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import UrlParse from 'url-parse';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import TrendSelection from '~/components/molecules/Editorial/Trend/TrendSelection.vue';
export default {
  name: 'TrendTheme',
  components: {
    TrendSelection: TrendSelection
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _this = this;

      var _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23;

      return {
        title: {
          color: ((_ref23 = this.payload) != null ? (_ref23 = _ref23.primary) != null ? _ref23.title_color : _ref23 : _ref23) || '',
          text: ((_ref22 = this.payload) != null ? (_ref22 = _ref22.primary) != null ? (_ref22 = _ref22.title) != null ? (_ref22 = _ref22[0]) != null ? _ref22.text : _ref22 : _ref22 : _ref22 : _ref22) || ''
        },
        description: ((_ref21 = this.payload) != null ? (_ref21 = _ref21.primary) != null ? (_ref21 = _ref21.description) != null ? (_ref21 = _ref21[0]) != null ? _ref21.text : _ref21 : _ref21 : _ref21 : _ref21) || '',
        colors: [((_ref20 = this.payload) != null ? (_ref20 = _ref20.primary) != null ? _ref20.one : _ref20 : _ref20) || '', ((_ref19 = this.payload) != null ? (_ref19 = _ref19.primary) != null ? _ref19.two : _ref19 : _ref19) || '', ((_ref18 = this.payload) != null ? (_ref18 = _ref18.primary) != null ? _ref18.three : _ref18 : _ref18) || '', ((_ref17 = this.payload) != null ? (_ref17 = _ref17.primary) != null ? _ref17.four : _ref17 : _ref17) || '', ((_ref16 = this.payload) != null ? (_ref16 = _ref16.primary) != null ? _ref16.five : _ref16 : _ref16) || ''],
        button: {
          text: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.button_text : _ref15 : _ref15) || '',
          url: new UrlParse(((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? (_ref14 = _ref14.button_url) != null ? _ref14.url : _ref14 : _ref14 : _ref14) || '').pathname,
          tracking: {
            data: {
              event_category: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.event_category : _ref13 : _ref13) || '',
              event_action: ((_ref12 = this.payload) != null ? (_ref12 = _ref12.primary) != null ? _ref12.event_action : _ref12 : _ref12) || '',
              event_label: ((_ref11 = this.payload) != null ? (_ref11 = _ref11.primary) != null ? _ref11.event_label : _ref11 : _ref11) || ''
            }
          }
        },
        selections: this.payload.items.map(function (i) {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10;

          return {
            image: {
              small: formatPrismicImage((_ref10 = i) != null ? (_ref10 = _ref10.background_image) != null ? (_ref10 = _ref10.small) != null ? _ref10.url : _ref10 : _ref10 : _ref10) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref9 = i) != null ? (_ref9 = _ref9.background_image) != null ? (_ref9 = _ref9.large) != null ? _ref9.url : _ref9 : _ref9 : _ref9) || EMPTY_PIXEL
            },
            title: ((_ref8 = i) != null ? (_ref8 = _ref8.title) != null ? (_ref8 = _ref8[0]) != null ? _ref8.text : _ref8 : _ref8 : _ref8) || '',
            subtitle: ((_ref7 = i) != null ? (_ref7 = _ref7.subtitle) != null ? (_ref7 = _ref7[0]) != null ? _ref7.text : _ref7 : _ref7 : _ref7) || '',
            withIcon: _this.withIcon(((_ref6 = i) != null ? _ref6.with_icon : _ref6) || ''),
            button: {
              text: ((_ref5 = i) != null ? _ref5.button_text : _ref5) || '',
              url: new UrlParse(((_ref4 = i) != null ? (_ref4 = _ref4.button_url) != null ? _ref4.url : _ref4 : _ref4) || '').pathname,
              tracking: {
                data: {
                  event_category: ((_ref3 = i) != null ? _ref3.event_category : _ref3) || '',
                  event_action: ((_ref2 = i) != null ? _ref2.event_action : _ref2) || '',
                  event_label: ((_ref = i) != null ? _ref.event_label : _ref) || ''
                }
              }
            }
          };
        })
      };
    }
  },
  methods: {
    withIcon: function withIcon(arg) {
      var result = false;

      if (arg === 'true') {
        result = true;
      }

      return result;
    }
  }
};